<style scoped>
	/*item-pay*/
	.item-pay {
		width: 300px;
		border: 1px solid rgba(226, 226, 226, 1);
		margin: 20px 0 auto 0;
	}

	.pay-title {
		height: 34px;
		line-height: 34px;
		color: #65717D;
		background: rgba(243, 248, 253, 1);
	}

	.pay-danger {
		color: rgba(255, 39, 46, 0.66);
	}

	.pay-success {
		color: #70ff8c;
	}

	.pay-content {
		display: flex;
		margin: 10px 2px;
	}

	.pay-content>.detail {
		font-size: 14px;
		text-align: center;
		flex: 2;
		cursor: pointer;
	}

	.pay-content>.detail:nth-child(1) {
		border-right: 1px solid #CCCCCC;
		font-weight: bold;
	}

	.pay-content>.detail:nth-child(2) {
		color: #999999;
	}

	.pay-content>.detail:nth-child(3) {
		flex: 1;
		font-weight: 400;
	}

	/*detail*/
	/*隐藏的时候将其高度设置为0*/
	.hide {
		height: 0 !important;
	}

	.detail-hr {
		border-top: 1px #CCCCCC dashed;
		margin-bottom: 10px;
	}

	.pay-detail {
		transition: height .31s;
		overflow: hidden;
		width: 90%;
		display: flex;
		flex-direction: column;
		margin: 0 auto;
	}

	.pay-detail>.detail-item {
		width: 100%;
		height: 23px;
		display: flex;
		flex-wrap: nowrap;
	}

	.pay-detail>.detail-item>.item-span:nth-child(1) {
		display: inline-block;
		flex: 1;
		text-align: right;
	}

	.pay-detail>.detail-item>.item-span:nth-child(2) {
		flex: 1;
		text-align: left;
	}

	/*item change style*/
	.item-pay-checked {
		border: 1px solid #0A76CE;
		background: url("../../../assets/images/right_down.png") no-repeat;
		background-position: calc(100% + 1px) calc(100% + 1px);
	}

	.item-pay-checked>.pay-title {
		color: #FFFFFF;
		background: rgba(10, 118, 206, .61);
	}

	.item-pay-checked>.pay-content>.detail:nth-child(2) {
		color: #EA2323;
	}

	.item-pay-checked>.pay-content>.detail:nth-child(3) {
		color: #0A76CE;
	}
</style>
<!-- item - pay -->
<template>
	<div class="item-pay " :class="itemClass + ' ' + (checked ? 'item-pay-checked' : '')">
		<p class="pay-title">{{$t('order.Paymenttime')}}：{{time}} <span :class="payok === 0 ? 'pay-danger' : 'pay-success'">({{payok === 0 ? $t('state.payment') : $t('order.Paid')}})</span></p>
		<div class="pay-content">
			<span class="detail">{{$t('order.d')}}{{count}}{{$t('order.q')}}</span>
			<span class="detail">{{`${$type == 1?'￥':'$'}` + (total / 100).toFixed(2)}}</span>
			<span class="detail" @click="showHide($event)">{{payItemShow ? $t('order.Putitaway') : $t('order.details')}} <span
				 :class="payItemShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></span></span>
		</div>
		<div class="pay-detail" :style="'height:'+ (details.length * 23 + 10) +'px;'" :class="payItemShow ? '' : 'hide'">
			<div class="detail-hr"></div>
			<div class="detail-item" v-for="item in details">
				<span class="item-span">{{item.key}}：</span>
				<span class="item-span">{{`${$type == 1?'￥':'$'}` + (item.value / 100).toFixed(2)}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "PayItemInOrderItem",
		props: {
			itemClass: {
				type: String,
				default: ''
			},
			count: {
				type: Number,
				default: -1
			},
			time: {
				type: String,
				default: '0000-00-00'
			},
			total: {
				type: Number,
				default: -1
			},
			details: {
				type: Array,
				default: []
			},
			ids: {
				type: String,
				default: ''
			},
			index: {
				type: Number,
				default: -1
			},
			checked: {
				type: Boolean,
				default: false
			},
			payok: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				payItemShow: false
			};
		},
		methods: {
			//是否显示详情
			showHide(e) {
				this.payItemShow = !this.payItemShow;
				e.cancelBubble = true;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/memberCenter/order/PayItemInOrderItem.vue